import fs from 'fs';
import path from 'path';

export function writeFile(filePath: string, content: string) {
	const folderPath = path.dirname(filePath);

	fs.mkdirSync(folderPath, { recursive: true });

	const tempFilePath = `${filePath}.${process.pid}.tmp`;

	try {
		fs.writeFileSync(tempFilePath, content, 'utf8');
		fs.renameSync(tempFilePath, filePath);
	} catch (error) {
		fs.rmSync(tempFilePath, { force: true });

		throw error;
	}
}
